import { render } from "./ClaimDetail.vue?vue&type=template&id=151938c8"
import script from "./ClaimDetail.vue?vue&type=script&lang=js"
export * from "./ClaimDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__